import { render, staticRenderFns } from "./ProtocolSummarizationWidget.view.vue?vue&type=template&id=5046c2c1&"
import script from "./ProtocolSummarizationWidget.view.vue?vue&type=script&lang=js&"
export * from "./ProtocolSummarizationWidget.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5046c2c1')) {
      api.createRecord('5046c2c1', component.options)
    } else {
      api.reload('5046c2c1', component.options)
    }
    module.hot.accept("./ProtocolSummarizationWidget.view.vue?vue&type=template&id=5046c2c1&", function () {
      api.rerender('5046c2c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/update/protocol/ProtocolSummarizationWidget.view.vue"
export default component.exports